import React, { useState, useEffect } from 'react';
import printHtml from '../printHtml';
import API from '../api/api';

function WhatsApp({ partnership, currentUser }) {
  const isAdmin = !currentUser || currentUser.role === 'admin';
  const [data, setData] = useState(null);
  const [partners, setPartners] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [selected, setSelected] = useState({});
  const [msgType, setMsgType] = useState('comprehensive');
  const [fromDate, setFromDateRaw] = useState('');
  const setFromDate = v => { setFromDateRaw(v); setScheduleAllData(null); };
  const [toDate, setToDateRaw] = useState(new Date().toISOString().split('T')[0]);
  const setToDate = v => { setToDateRaw(v); setScheduleAllData(null); };
  const [preview, setPreview] = useState('');
  const [billSessions, setBillSessions] = useState(null);
  const [selectedBillId, setSelectedBillId] = useState(null);
  const [scheduleAllData, setScheduleAllData] = useState(null);
  const [queue, setQueue] = useState([]);
  const [queueIdx, setQueueIdx] = useState(0);
  const [showQueue, setShowQueue] = useState(false);
  const [manualQueue, setManualQueue] = useState([]);
  const [manualQueueIdx, setManualQueueIdx] = useState(0);
  const [showManualQueue, setShowManualQueue] = useState(false);
  const [copied, setCopied] = useState(false);
  const [greeting, setGreeting] = useState('السلام عليكم ورحمة الله وبركاته');
  const [closing, setClosing] = useState('');
  const [groupFooter, setGroupFooter] = useState('نسأل الله لكم التوفيق والسداد 🤲');
  const [waAcc, setWaAcc] = useState(null);

  const fmt = n => Number(n||0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits:2, maximumFractionDigits:2});
  const fmtH = n => Number(n||0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits:1, maximumFractionDigits:1});
  const fmtExactDH = (daysDec, hoursDec) => {
    daysDec = Math.round((daysDec||0) * 100) / 100;
    hoursDec = Math.round((hoursDec||0) * 100) / 100;
    let dayPart = '';
    if (daysDec > 0) {
      const whole = Math.floor(daysDec + 1e-9);
      const rem = Math.round((daysDec - whole) * 4) / 4;
      if (whole > 0) dayPart += whole + ' يوم';
      if (rem === 0.5) dayPart += (dayPart ? ' و' : '') + 'نصف يوم';
      else if (rem === 0.25) dayPart += (dayPart ? ' و' : '') + 'ربع يوم';
      else if (rem === 0.75) dayPart += (dayPart ? ' و' : '') + 'ثلاثة أرباع اليوم';
    }
    let hourPart = '';
    if (hoursDec > 0) {
      const hoursStr = Number.isInteger(hoursDec) ? String(hoursDec) : hoursDec.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits:2});
      hourPart = hoursStr + ' ساعة';
    }
    if (!dayPart && !hourPart) return '—';
    return dayPart && hourPart ? `${dayPart} و${hourPart}` : (dayPart || hourPart);
  };
  const sumExactDH = (sessionsArr, fromDate, toDate, partnerId) => {
    let days = 0, hours = 0;
    (sessionsArr||[]).forEach(s => {
      if (s.no_operation) return;
      if (fromDate && s.date < fromDate) return;
      if (toDate && s.date > toDate) return;
      if (partnerId != null) {
        const pid = s.sub_partner_id != null ? s.sub_partner_id : s.partner_id;
        if (String(pid) !== String(partnerId)) return;
      }
      if (s.run_type === 'full') days += 1;
      else if (s.run_type === 'half') days += 0.5;
      else if (s.run_type === 'quarter') days += 0.25;
      else if (s.run_type === 'hours') hours += parseFloat(s.hours || 0);
      hours += parseFloat(s.extra_hours || 0);
    });
    return { days, hours };
  };

  useEffect(() => {
    API.get(`/summary/${partnership.id}/`).then(res => {
      setData(res.data);
      setPartners(res.data.partners || []);
      if (res.data.partnership?.start_date) setFromDate(res.data.partnership.start_date);
    });
    API.get(`/reports/${partnership.id}/?type=summary_all`).then(res => {
      setReportData(res.data);
      const bills = res.data.bill_details || [];
      if (bills.length > 0) {
        const lastBill = bills[bills.length - 1];
        const nextDay = new Date(lastBill.to_date);
        nextDay.setDate(nextDay.getDate() + 1);
        setFromDate(nextDay.toISOString().split('T')[0]);
      }
    });
    API.get(`/settings/${partnership.id}/`).then(res => {
      const st = res.data.settings || res.data;
      if (st.whatsapp_greeting) setGreeting(st.whatsapp_greeting);
      if (st.whatsapp_closing) setClosing(st.whatsapp_closing);
      if (st.wa_group_footer !== undefined) setGroupFooter(st.wa_group_footer);
      setWaAcc({
        hours_txt: st.wa_acc_hours_txt||'',
        account_txt: st.wa_acc_account_txt||'',
        bal_pos: st.wa_acc_bal_pos||'',
        bal_neg: st.wa_acc_bal_neg||'',
        bills_title: st.wa_acc_bills_title||'',
        bill_line: st.wa_acc_bill_line||'',
        footer: st.wa_acc_footer||'',
        comp_show_hours:   st.wa_comp_show_hours !== false,
        comp_show_account: st.wa_comp_show_account !== false,
        comp_show_bills:   st.wa_comp_show_bills !== false,
        comp_show_balance: st.wa_comp_show_balance !== false,
        comp_greeting:     st.wa_comp_greeting||'',
        comp_title:        st.wa_comp_title||'',
        comp_hours_txt:    st.wa_comp_hours_txt||'',
        comp_account_txt:  st.wa_comp_account_txt||'',
        comp_bills_txt:    st.wa_comp_bills_txt||'',
        comp_footer:       st.wa_comp_footer||'',
        comp_opening:      st.wa_comp_opening||'',
        comp_hours_body:   st.wa_comp_hours_body||'',
        comp_account_body: st.wa_comp_account_body||'',
        comp_bal_pos:      st.wa_comp_bal_pos||'',
        comp_bal_neg:      st.wa_comp_bal_neg||'',
        comp_bill_line:    st.wa_comp_bill_line||'',
        comp_show_expenses: st.wa_comp_show_expenses !== false,
        comp_show_revenues: st.wa_comp_show_revenues !== false,
        bill_opening:       st.wa_bill_opening||'',
        bill_title:         st.wa_bill_title||'',
        bill_hours_title:   st.wa_bill_hours_title||'',
        bill_session_line:  st.wa_bill_session_line||'',
        bill_bal_zero:      st.wa_bill_bal_zero||'',
        bill_bal_pos:       st.wa_bill_bal_pos||'',
        bill_bal_neg:       st.wa_bill_bal_neg||'',
        bill_footer:        st.wa_bill_footer||'',
        bill_show_sessions: st.wa_bill_show_sessions !== false,
        bill_show_balance:  st.wa_bill_show_balance !== false,
        sched_all_title:   st.wa_sched_all_title||'',
        sched_all_row:     st.wa_sched_all_row||'',
        sched_all_footer:  st.wa_sched_all_footer||'',
        sched_one_opening: st.wa_sched_one_opening||'',
        sched_one_title:   st.wa_sched_one_title||'',
        sched_one_row:     st.wa_sched_one_row||'',
        sched_one_empty:   st.wa_sched_one_empty||'',
        sched_one_footer:  st.wa_sched_one_footer||'',
        whatsapp_api_note: st.whatsapp_api_note||'',
      });
    });
  }, [partnership.id]);

  const buildMsg = (p) => {
    const bal = parseFloat(p.balance || 0);
    const balText = Math.abs(bal) < 0.01 ? '✅ مسدد' : bal > 0 ? `✅ رصيدك: ${fmt(bal)} ريال` : `⚠️ لم يسدد - المبلغ المطلوب: ${fmt(Math.abs(bal))} ريال`;
    if (waAcc) {
      const pd0 = reportData?.summary?.find(s => s.id === p.id);
      const balPosTxt = waAcc.bal_pos.replaceAll('{رصيد_موجب}', fmt(Math.abs(bal)));
      const balNegTxt = waAcc.bal_neg.replaceAll('{رصيد_سالب}', fmt(Math.abs(bal)));
      const balLine = Math.abs(bal) < 0.01 ? balPosTxt.replace('{رصيد_موجب}','0.00') : bal > 0 ? balPosTxt : balNegTxt;
      let m = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
      m += `المكرم / ${p.name}\nسلمكم الله\n${greeting}\n`;
      m += `${"─".repeat(28)}\n`;
      if (msgType === 'account' || msgType === 'both') {
        let accTxt = waAcc.account_txt;
        accTxt = accTxt.replaceAll('{مستحق}', fmt(p.total_due));
        accTxt = accTxt.replaceAll('{مدفوع}', fmt(p.paid));
        m += `\n${accTxt}\n• ${balLine}\n`;
      }
      if ((msgType === 'schedule' || msgType === 'both') && pd0) {
        const isDaysS = partnership.quota_type === 'days';
        const cycleStartS = data?.partnership?.start_date || '';
        const cycleEndS = new Date().toISOString().split('T')[0];
        let hTxt = waAcc.hours_txt;
        hTxt = hTxt.replaceAll('{ساعات}', fmtH(p.hours));
        hTxt = hTxt.replaceAll('{نسبة}', parseFloat(p.hours_pct||0).toFixed(1));
        m += `\n${hTxt}\n`;
        if (isDaysS) {
          const exactS = sumExactDH(data?.sessions, cycleStartS, cycleEndS, p.id);
          m += `• إجمالي تشغيلك: ${fmtExactDH(exactS.days, exactS.hours)}\n`;
        }
        const allSessionsS = (data?.sessions||[]).filter(s => {
          if (s.no_operation) return false;
          return (String(s.partner_id)===String(p.id)&&!s.sub_partner_id)||(String(s.sub_partner_id)===String(p.id));
        });
        if (allSessionsS.length > 0) {
          m += `\n📅 *أيام التشغيل خلال الدورة الحالية من ${cycleStartS} إلى ${cycleEndS}:*\n`;
          allSessionsS.forEach(s => {
            const type = (String(s.partner_id)===String(p.id)&&!s.sub_partner_id) ? 'أساسي' : 'بديل';
            const hTotalMins = Math.round(s.total_hours * 60);
            const hH = Math.floor(hTotalMins/60); const hM = hTotalMins%60;
            const hDisp = hM>0 ? `${hH} ساعة و${hM} دقيقة` : `${hH} ساعة`;
            m += `📆 *${s.date}* (${s.day}) - ${type} - ${hDisp}\n`;
          });
        }
      }
      if (msgType === 'expenses' || msgType === 'both') {
        m += `\n📋 *المصروفات:*\n• نصيبك من المصروفات: ${fmt(p.expenses_due)} ريال\n`;
      }
      if (msgType === 'bills' || msgType === 'both') {
        m += `\n${waAcc.bills_title}\n`;
        const billDetails = reportData?.bill_details || [];
        const isDays = partnership.quota_type === 'days';
        const avgMins = Math.floor(reportData?.totals?.avg_day_minutes || 869);
        if (billDetails.length > 0) {
          billDetails.forEach((bill, idx) => {
            const bHrs = ((bill.partner_hours?.[String(p.id)]||bill.partner_hours?.[p.id]||0) + (bill.partner_extra_hours?.[String(p.id)]||bill.partner_extra_hours?.[p.id]||0));
            const bShare = bill.shares?.[String(p.id)]||bill.shares?.[p.id]||0;
            if(isDays) {
              const bExact = sumExactDH(data?.sessions, bill.from_date, bill.to_date, p.id);
              m += `• فاتورة ${idx+1} ( ${bill.from_date} ← ${bill.to_date} ) · ساعاتك: *${fmtExactDH(bExact.days, bExact.hours)}* · مستحقك: *${fmt(bShare)}* ريال\n`;
            } else {
              m += `• فاتورة ${idx+1} ( ${bill.from_date} ← ${bill.to_date} ) · ساعاتك: *${fmtH(bHrs)}* ساعة · مستحقك: *${fmt(bShare)}* ريال\n`;
            }
          });
        } else {
          m += waAcc.bill_line.replaceAll('{مستحق_ف}', fmt(p.bills_due)).replaceAll('{رقم}','').replaceAll('{من}','').replaceAll('{إلى}','').replaceAll('{ساعات_ف}','') + `\n`;
        }
      }
      let footerTxt = waAcc.footer.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'));
      m += `\n${footerTxt}`;
      return m;
    }
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `المكرم / ${p.name}\nسلمكم الله\n${greeting}\n`;
    msg += `${"─".repeat(28)}\n`;

    if (msgType === 'account' || msgType === 'both') {
      msg += `\n💰 *حسابك:*\n`;
      msg += `• المستحق عليك: ${fmt(p.total_due)} ريال\n`;
      msg += `• دفعت: ${fmt(p.paid)} ريال\n`;
      msg += `• ${balText}\n`;
    }

    if (msgType === 'schedule' || msgType === 'both') {
      {
        const isDays = partnership.quota_type === 'days';
        const cycleStart = data?.partnership?.start_date || '';
        const cycleEnd = new Date().toISOString().split('T')[0];
        msg += `\n⚡ *ساعات التشغيل:*\n`;
        if (isDays) {
          const exactMain = sumExactDH(data?.sessions, cycleStart, cycleEnd, p.id);
          msg += `• إجمالي تشغيلك: ${fmtExactDH(exactMain.days, exactMain.hours)} (${parseFloat(p.hours_pct||0).toFixed(1)}٪ من الإجمالي)\n`;
          msg += `• إجمالي ساعاتك: ${fmtH(p.hours)} ساعة\n`;
        } else {
          msg += `• إجمالي ساعاتك: ${fmtH(p.hours)} ساعة (${parseFloat(p.hours_pct||0).toFixed(1)}٪ من الإجمالي)\n`;
        }
        const allSessions = (data?.sessions||[]).filter(s => {
          if (s.no_operation) return false;
          const isMain = s.partner_id === p.id && !s.sub_partner_id;
          const isSub = s.sub_partner_id === p.id;
          const isMain2 = String(s.partner_id) === String(p.id) && !s.sub_partner_id;
          const isSub2 = String(s.sub_partner_id) === String(p.id);
          const isBadil = String(s.partner_id)===String(p.id)&&s.sub_partner_id&&String(s.sub_partner_id)!==String(p.id);
          return (isMain || isSub || isMain2 || isSub2) && !isBadil;
        });
        if (allSessions.length > 0) {
          msg += `\n📅 *أيام التشغيل خلال الدورة الحالية من ${cycleStart} إلى ${cycleEnd}:*\n`;
          allSessions.forEach(s => {
            const isMainT = (s.partner_id === p.id||String(s.partner_id)===String(p.id)) && !s.sub_partner_id;
            const type = isMainT ? 'أساسي' : 'بديل';
            const hTM=Math.round(s.total_hours*60);const hTH=Math.floor(hTM/60);const hTMin=hTM%60;
            const hrsDisplay=hTMin>0?`${hTH} ساعة و${hTMin} دقيقة`:`${hTH} ساعة`;
            msg += `📆 *${s.date}* (${s.day}) - ${type} - ${hrsDisplay}\n`;
          });
        }
      }
    }

    if (msgType === 'expenses' || msgType === 'both') {
      msg += `\n📋 *المصروفات:*\n`;
      msg += `• نصيبك من المصروفات: ${fmt(p.expenses_due)} ريال\n`;
    }

    if (msgType === 'bills' || msgType === 'both') {
      msg += `\n⚡ *فواتير الكهرباء:*\n`;
      msg += `• نصيبك من الفواتير: ${fmt(p.bills_due)} ريال\n`;
    }

    msg += `\n📅 تاريخ الإرسال: ${new Date().toLocaleDateString('ar-SA')}\n`;
    return msg;
  };

  const buildComprehensiveMsg = (p, summaryData) => {
    const sep = '─'.repeat(28);
    const totals = summaryData?.totals || {};
    const bills = summaryData?.bill_details || [];
    const lastBill = bills[bills.length - 1];
    const lastBillMins = lastBill ? (lastBill.partner_minutes?.[String(p.id)] ?? lastBill.partner_minutes?.[p.id] ?? ((lastBill.partner_hours?.[String(p.id)]||lastBill.partner_hours?.[p.id]||0) + (lastBill.partner_extra_hours?.[String(p.id)]||lastBill.partner_extra_hours?.[p.id]||0))*60) : 0;
    const lastBillHrs = lastBillMins/60;

    const waComp = waAcc || {};
    const compOpening     = waComp.comp_opening     || 'المكرم الأخ / {اسم} حفظكم الله';
    const compGreeting    = waComp.comp_greeting    || 'وأسعد الله أوقاتك بكل خير';
    const compTitle       = waComp.comp_title       || '📊 *تقرير شامل*\n( المصروفات - الإيرادات - الفواتير - عدد ساعات التشغيل )';
    const compHoursBody   = waComp.comp_hours_body  || '• ساعات التشغيل الخاصة بكم: *{ساعات}*\n• نسبة تشغيلكم: *{نسبة}٪*';
    const compAccountBody = waComp.comp_account_body|| '• المستحق عليكم: *{مستحق}* ريال\n• إجمالي ما دفعتم: *{مدفوع}* ريال';
    const compBalPos      = waComp.comp_bal_pos     || '✅ *مسدد* · ورصيدكم ({رصيد_موجب}) ريال';
    const compBalNeg      = waComp.comp_bal_neg     || '⚠️ *لم يسدد* · والمبلغ المطلوب سداده ({رصيد_سالب}) ريال';
    const compBillsTxt    = waComp.comp_bills_txt   || '🔌 *الفواتير:*';
    const compBillLine    = waComp.comp_bill_line   || '• فاتورة {رقم} ({من} ← {إلى}) · ساعاتكم: *{ساعات_ف}* · مستحقكم: *{مستحق_ف}* ريال';
    const compFooter      = waComp.comp_footer      || 'للإحاطة والاطلاع 🤝\n📆 تاريخ الإرسال: {تاريخ}';
    const showHours    = waComp.comp_show_hours    !== false;
    const showAccount  = waComp.comp_show_account  !== false;
    const showBills    = waComp.comp_show_bills    !== false;
    const showBalance  = waComp.comp_show_balance  !== false;
    const showExpenses = waComp.comp_show_expenses !== false;
    const showRevenues = waComp.comp_show_revenues !== false;

    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${sep}\n`;
    const openingText = compOpening.replaceAll('{اسم}', p.name);
    msg += `${openingText}\n`;
    msg += `${greeting}\n`;
    if (compGreeting) msg += `${compGreeting}\n`;
    msg += `${sep}\n`;
    msg += `${compTitle}\n`;
    const startDate = summaryData?.partnership?.start_date || fromDate || '';
    msg += `خلال الفترة من ${startDate} إلى ${toDate}\n`;
    msg += `${sep}\n`;
    const totalAllExpenses = parseFloat(totals.expenses||0) + parseFloat(totals.bills||0);
    const totalPartnerExpenses = parseFloat(p.expenses_due||0) + parseFloat(p.bills_due||0);
    if (showExpenses) {
      msg += `💰 *المصروفات:*\n`;
      msg += `• المبلغ الكلي للمصروفات (شاملة الفواتير): *${fmt(totalAllExpenses)}* ريال\n`;
      msg += `• المصروفات الخاصة بكم: *${fmt(p.expenses_due||0)}* ريال\n`;
      msg += `• الفواتير الخاصة بكم: *${fmt(p.bills_due||0)}* ريال\n`;
      msg += `• المصروفات شاملة الفواتير: *${fmt(totalPartnerExpenses)}* ريال\n`;
      msg += `${sep}\n`;
    }
    if (showRevenues) {
      msg += `💵 *الإيرادات:*\n`;
      msg += `• المبلغ الكلي للإيرادات: *${fmt(totals.paid||0)}* ريال\n`;
      msg += `• الإيرادات الخاصة بكم: *${fmt(p.paid||0)}* ريال\n`;
      msg += `• ما تم تحصيلها منكم: *${fmt(p.paid||0)}* ريال\n`;
      msg += `${sep}\n`;
    }
    const isDays = partnership.quota_type === 'days';
    const partnerHrsPct = totals.hours > 0 ? ((parseFloat(p.hours||0)/totals.hours)*100).toFixed(1) : '0.0';
    const minsToDisplay = (totalMins, avgMins) => {
      totalMins = Math.round(totalMins); avgMins = Math.floor(avgMins);
      const halfMins = Math.floor(avgMins/2); const quarterMins = Math.floor(avgMins/4);
      const days = Math.floor(totalMins/avgMins); let rem = totalMins % avgMins;
      let half=0, quarter=0;
      if(rem>=halfMins){half=1;rem-=halfMins;} else if(rem>=quarterMins){quarter=1;rem-=quarterMins;}
      const hours = Math.floor(rem/60); const minutes = rem%60;
      let s='';
      if(days>0) s+=days+' يوم';
      if(half>0) s+=(s?' و':'')+'نصف يوم';
      if(quarter>0) s+=(s?' و':'')+'ربع يوم';
      if(hours>0) s+=(s?' و':'')+hours+' ساعة';
      if(minutes>0) s+=(s?' و':'')+minutes+' دقيقة';
      return s||'—';
    };
        const avgMins = Math.floor(totals.avg_day_minutes || 869);
    if (showHours) {
      const hoursVal = isDays ? (() => { const ex = sumExactDH(summaryData?.sessions, startDate, toDate, p.id); return fmtExactDH(ex.days, ex.hours); })() : fmtH(p.hours||0);
      const hoursBodyText = compHoursBody
        .replaceAll('{ساعات}', hoursVal)
        .replaceAll('{نسبة}', partnerHrsPct);
      msg += `⏱️ *${isDays?'أيام':'ساعات'} التشغيل:*\n`;
      msg += `${hoursBodyText}\n`;
      if (lastBill) {
        const lastBillTotalHrs = lastBill.total_hours || 0;
        const lastBillPct = lastBillTotalHrs > 0 ? ((lastBillHrs/lastBillTotalHrs)*100).toFixed(1) : '0.0';
        const lastHrsVal = isDays ? (() => { const ex = sumExactDH(summaryData?.sessions, lastBill.from_date, lastBill.to_date, p.id); return fmtExactDH(ex.days, ex.hours); })() : fmtH(lastBillHrs);
        const lastTotalVal = isDays ? (() => { const ex = sumExactDH(summaryData?.sessions, lastBill.from_date, lastBill.to_date, null); return fmtExactDH(ex.days, ex.hours); })() : fmtH(lastBillTotalHrs);
        msg += `• ${isDays?'زمن':'ساعات'} تشغيلكم في الفاتورة الأخيرة: *${lastHrsVal}* من أصل *${lastTotalVal}* (${lastBillPct}٪)\n`;
      }
      msg += `${sep}\n`;
    }
    // جدول التشغيل خلال الفاتورة الأخيرة
    const lastBillForSchedule = bills[bills.length-1];
    const billFromDate = lastBillForSchedule?.from_date || '';
    const billToDate = lastBillForSchedule?.to_date || '';
    const partnerSessions = (summaryData?.sessions || []).filter(s => {
      if (s.no_operation) return false;
      if (billFromDate && s.date < billFromDate) return false;
      if (billToDate && s.date > billToDate) return false;
      const isMain = s.partner_id === p.id && !s.sub_partner_id;
      const isSub = s.sub_partner_id === p.id;
      return isMain || isSub;
    });
    if (partnerSessions.length > 0) {
      const firstDate = partnerSessions[0].date;
      const lastDate = partnerSessions[partnerSessions.length-1].date;
      msg += `📅 *جدول تشغيلك*\n`;
      msg += `من ${firstDate} إلى ${lastDate}\n`;
      msg += `${sep}\n`;
      partnerSessions.forEach(s => {
        const isMain = s.partner_id === p.id && !s.sub_partner_id;
        const isSub = s.sub_partner_id === p.id;
        const type = isMain ? 'أساسي' : isSub ? 'بديل' : 'طارئ';
        msg += `📆 *${s.date}* (${s.day}) - ${type}\n`;
      });
      msg += `${sep}\n`;
    }
        if (showBills) {
      msg += `${compBillsTxt}\n`;
      if (bills.length > 0) {
        bills.forEach((bill, idx) => {
          const bHrs = ((bill.partner_hours?.[String(p.id)]||bill.partner_hours?.[p.id]||0)+(bill.partner_extra_hours?.[String(p.id)]||bill.partner_extra_hours?.[p.id]||0));
          const bShare = bill.shares?.[String(p.id)]||bill.shares?.[p.id]||0;
          const hoursVal = isDays ? (() => { const ex = sumExactDH(summaryData?.sessions, bill.from_date, bill.to_date, p.id); return fmtExactDH(ex.days, ex.hours); })() : fmtH(bHrs);
          const billText = compBillLine
            .replaceAll('{رقم}', idx+1)
            .replaceAll('{من}', bill.from_date||'')
            .replaceAll('{إلى}', bill.to_date||'')
            .replaceAll('{ساعات_ف}', hoursVal)
            .replaceAll('{مستحق_ف}', fmt(bShare));
          msg += `${billText}\n`;
        });
      } else {
        msg += `• مبالغ الفواتير الخاصة بكم: *${fmt(p.bills_due||0)}* ريال\n`;
      }
    }
    if (showBalance) {
      msg += `${sep}\n`;
      const bal2 = parseFloat(p.balance||0);
      const balLine2 = Math.abs(bal2)<0.01
        ? compBalPos.replaceAll('{رصيد_موجب}','0.00')
        : bal2>0
          ? compBalPos.replaceAll('{رصيد_موجب}', fmt(bal2))
          : compBalNeg.replaceAll('{رصيد_سالب}', fmt(Math.abs(bal2)));
      msg += `• ${balLine2}\n`;
    }
    if (showAccount) {
      msg += `${sep}\n`;
      const accountText = compAccountBody
        .replaceAll('{مستحق}', fmt(p.total_due||0))
        .replaceAll('{مدفوع}', fmt(p.paid||0));
      msg += `${compBillsTxt.replace('🔌','💰').replace('الفواتير','الحساب')}\n`;
      msg += `${accountText}\n`;
    }
    msg += `${sep}\n`;
    const compFooterFinal = compFooter.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'));
    msg += `${compFooterFinal}`;
    return msg;
  };

  const buildBillMsg = (p, sessions, bill) => {
    if (!bill) return 'جاري تحميل بيانات الفاتورة...';
    const waB = waAcc || {};
    const billOpening     = waB.bill_opening     || 'المكرم الأخ / {اسم} حفظكم الله';
    const billTitle       = waB.bill_title       || '📋 *صدرت الفاتورة الحالية*';
    const billHoursTitle  = waB.bill_hours_title || '📅 *أيام/ساعات التشغيل مدة الفاتورة:*';
    const billSessionLine = waB.bill_session_line|| '• يوم {يوم} {تاريخ} - {نوع} - مدة التشغيل: *{ساعات}*';
    const billBalZero     = waB.bill_bal_zero    || '• الرصيد الحالي: *صفر* ✅';
    const billBalPos      = waB.bill_bal_pos     || '• الرصيد الحالي: له رصيد *{رصيد_موجب}* ريال ✅';
    const billBalNeg      = waB.bill_bal_neg     || '• الرصيد الحالي: مدين *{رصيد_سالب}* ريال ⚠️';
    const billFooter      = waB.bill_footer      || '• نشكر لكم مبادرتكم كما تعودنا منكم 🤲\n📆 تاريخ الإرسال: {تاريخ}';
    const billShowSessions = waB.bill_show_sessions !== false;
    const billShowBalance  = waB.bill_show_balance  !== false;
    const sep = '─'.repeat(28);
    const totalHrs = sessions.reduce((a,s)=>a+s.hours, 0);
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${billOpening.replaceAll('{اسم}', p.name)}\n`;
    msg += `${greeting}\n`;
    msg += `${sep}\n`;
    msg += `${billTitle}\n`;
    msg += `خلال الفترة من ${bill.from_date} إلى ${bill.to_date}\n`;
    msg += `${sep}\n`;
    const isBillDays = partnership.quota_type === 'days';
    const billAvgMins = Math.floor((bill.avg_day_minutes || 869));
    const billMinsToDisplay = (totalMins, avgMins) => {
      totalMins = Math.round(totalMins); avgMins = Math.floor(avgMins);
      const halfMins = Math.floor(avgMins/2); const quarterMins = Math.floor(avgMins/4);
      const days = Math.floor(totalMins/avgMins); let rem = totalMins % avgMins;
      let half=0, quarter=0;
      if(rem>=halfMins){half=1;rem-=halfMins;} else if(rem>=quarterMins){quarter=1;rem-=quarterMins;}
      const hours = Math.floor(rem/60); const minutes = rem%60;
      let s='';
      if(days>0) s+=days+' يوم';
      if(half>0) s+=(s?' و':'')+'نصف يوم';
      if(quarter>0) s+=(s?' و':'')+'ربع يوم';
      if(hours>0) s+=(s?' و':'')+hours+' ساعة';
      if(minutes>0) s+=(s?' و':'')+minutes+' دقيقة';
      return s||'—';
    };
    if(isBillDays) {
      msg += `⏱️ زمن التشغيل مدة الفاتورة: *${billMinsToDisplay(totalHrs*60, billAvgMins)}*\n`;
      const exBill = sumExactDH(data?.sessions, bill.from_date, bill.to_date, p.id);
      msg += `📅 أيام/ساعات التشغيل مدة الفاتورة: *${fmtExactDH(exBill.days, exBill.hours)}*\n`;
    } else {
      const totalHrsInt = Math.floor(totalHrs);
    const totalMinutes = Math.round((totalHrs - totalHrsInt) * 60);
    const hrsDisplay = totalMinutes > 0 ? `${totalHrsInt} ساعة و${totalMinutes} دقيقة` : `${totalHrsInt} ساعة`;
    msg += `⏱️ ساعات التشغيل مدة الفاتورة: *${hrsDisplay}*\n`;
    }
    if (billShowSessions && sessions.length > 0) {
      msg += `${sep}\n`;
      msg += `${billHoursTitle}\n`;
      sessions.forEach(s => {
        const hrsVal = isBillDays ? billMinsToDisplay(s.hours*60, billAvgMins) : `${s.hours} ساعة`;
        msg += `${billSessionLine.replaceAll('{يوم}',s.day).replaceAll('{تاريخ}',s.date).replaceAll('{نوع}',s.op_type||'').replaceAll('{ساعات}',hrsVal)}\n`;
      });
    }
    msg += `${sep}\n`;
    const bal = parseFloat(p.balance || 0);
    if (billShowBalance) {
      if (Math.abs(bal) < 0.01) {
        msg += `${billBalZero}\n`;
      } else if (bal > 0) {
        msg += `${billBalPos.replaceAll('{رصيد_موجب}', fmt(bal))}\n`;
      } else {
        msg += `${billBalNeg.replaceAll('{رصيد_سالب}', fmt(Math.abs(bal)))}\n`;
      }
    }
    msg += `${sep}\n`;
    msg += `${billFooter.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
    return msg;
  };

  const buildGroupMsg = () => {
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${greeting}\n`;
    msg += `${"─".repeat(28)}\n`;
    msg += `\n💰 *ملخص حسابات الشركاء:*\n\n`;
    partners.forEach(p => {
      const bal = parseFloat(p.balance||0);
      const balIcon = Math.abs(bal)<0.01?'✅':bal>0?'✅':'⚠️';
      msg += `${balIcon} *${p.name}*\n`;
      msg += `   المستحق: ${fmt(p.total_due)} | دفع: ${fmt(p.paid)}\n`;
      msg += `   ${Math.abs(bal)<0.01?'مسدد':bal>0?'رصيد: +'+fmt(bal):'مديون: '+fmt(Math.abs(bal))} ريال\n\n`;
    });
    msg += `📅 ${new Date().toLocaleDateString('ar-SA')}\n`;
    if(groupFooter) msg += `
${groupFooter}`;
    return msg;
  };



  const buildScheduleAllMsg = () => {
    const waS = waAcc || {};
    const schedAllTitle  = waS.sched_all_title  || '📅 *جدول مواعيد التشغيل*';
    const schedAllRow    = waS.sched_all_row    || '📆 *{تاريخ}* ({يوم}) ← 👤 {شريك}';
    const schedAllFooter = waS.sched_all_footer || 'نسأل الله لكم التوفيق والسداد 🤲\n📅 تاريخ الإرسال: {تاريخ}';
    const sep = '─'.repeat(28);
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${sep}\n`;
    msg += `${schedAllTitle}\n`;
    msg += `من ${fromDate} إلى ${toDate}\n`;
    msg += `${sep}\n`;
    const sessList = (scheduleAllData?.sessions || []).filter(s => !s.no_operation);
    sessList.forEach(s => {
      const hoursTxt = ` - ${fmtH(s.total_hours ?? s.hours ?? 0)} ساعة`;
      const opTypeTxt = ` (${s.op_type === 'طارئ' ? 'طارئ' : s.sub_partner_name ? 'بديل' : 'أساسي'})`;
      const displayName = s.real_operator_name || s.partner_name;
      msg += `${schedAllRow.replaceAll('{تاريخ}',s.date).replaceAll('{يوم}',s.day).replaceAll('{شريك}',displayName)}${opTypeTxt}${hoursTxt}\n`;
    });
    msg += `${sep}\n`;
    msg += `${schedAllFooter.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
    return msg;
  };

  const buildScheduleOneMsg = (p, sdata) => {
    const waS = waAcc || {};
    const schedOneOpening = waS.sched_one_opening || 'المكرم الأخ / {اسم} حفظه الله';
    const schedOneTitle   = waS.sched_one_title   || '📅 *جدول مواعيد تشغيلك*';
    const schedOneRow     = waS.sched_one_row     || '📆 *{تاريخ}* ({يوم})';
    const schedOneEmpty   = waS.sched_one_empty   || 'لا توجد مواعيد تشغيل لك خلال هذه الفترة';
    const schedOneFooter  = waS.sched_one_footer  || 'نسأل الله لكم التوفيق 🤲\n📅 تاريخ الإرسال: {تاريخ}';
    const sep = '─'.repeat(28);
    const rows = (sdata?.schedule_rows || []).filter(r => r.partner_id === p.id);
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${schedOneOpening.replaceAll('{اسم}', p.name)}\n`;
    msg += `${greeting}\n`;
    msg += `${sep}\n`;
    msg += `${schedOneTitle}\n`;
    msg += `من ${fromDate} إلى ${toDate}\n`;
    msg += `${sep}\n`;
    if (rows.length === 0) {
      msg += `${schedOneEmpty}\n`;
    }
    rows.forEach(r => {
      msg += `${schedOneRow.replaceAll('{تاريخ}',r.date).replaceAll('{يوم}',r.day)}\n`;
    });
    msg += `${sep}\n`;
    msg += `${schedOneFooter.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
    return msg;
  };

  useEffect(() => {
    if (msgType === 'bill_schedule' && partners.length > 0) {
      const bills = data?.bill_details || [];
      if (bills.length > 0 && !selectedBillId) setSelectedBillId(bills[bills.length-1].id);
    }
    if (msgType === 'bill_current' && partners.length > 0) {
      API.get(`/bill-sessions/${partnership.id}/?partner_id=${partners[0].id}`)
        .then(res => setBillSessions(res.data));
    }
    if (msgType === 'schedule_all' || msgType === 'schedule_one') {
      API.get(`/reports/${partnership.id}/?type=schedule_dates&from_date=${fromDate}&to_date=${toDate}`)
        .then(res => setScheduleAllData(res.data));
    }
  }, [msgType, partners, fromDate, toDate]);

  useEffect(() => {
    if (!partners.length) return;
    if (msgType === 'group_summary') {
      setPreview(buildGroupMsg());
    } else if (msgType === 'bill_current_all') {
      setPreview(buildBillAllMsg());
    } else if (msgType === 'bill_current_one') {
      setPreview(buildBillOneMsg(partners[0]));
    } else if (msgType === 'bill_current') {
      if (billSessions) setPreview(buildBillMsg(partners[0], billSessions.sessions||[], billSessions.bill));
    } else if (msgType === 'bill_schedule') {
      const bills = data?.bill_details || [];
      const bill = bills.find(b=>b.id===selectedBillId) || bills[bills.length-1];
      if (bill) {
        const p = partners[0];
        const sep = '─'.repeat(28);
        const billSess = (data?.sessions||[]).filter(s => {
          if (s.no_operation) return false;
          if (s.date < bill.from_date || s.date > bill.to_date) return false;
          const isMain = s.partner_id === p.id && !s.sub_partner_id;
          const isSub = s.sub_partner_id === p.id;
          const isExtra = (s.extra_list||[]).some(e=>e.partner_id===p.id);
          return isMain || isSub || isExtra;
        });
        let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
        msg += `${sep}\n`;
        msg += `${greeting}\n`;
        msg += `${sep}\n`;
        msg += `📅 *جدول التشغيل*\n`;
        msg += `فاتورة ${bill.number} · من ${bill.from_date} إلى ${bill.to_date}\n`;
        msg += `${sep}\n`;
        let totalHours = 0;
        billSess.forEach(s => {
          const isMain = s.partner_id === p.id && !s.sub_partner_id;
          const isSub = s.sub_partner_id === p.id;
          const type = isMain ? 'أساسي' : isSub ? 'بديل' : 'طارئ';
          const sessHours = isMain || isSub ? (s.total_hours ?? s.hours ?? 0) : ((s.extra_list||[]).find(e=>e.partner_id===p.id)?.hours || 0);
          totalHours += Number(sessHours || 0);
          msg += `📆 *${s.date}* (${s.day}) - ${type} - ${fmtH(sessHours)} ساعة\n`;
        });
        if (billSess.length === 0) msg += `• لا يوجد تشغيل خلال هذه الفاتورة\n`;
        msg += `${sep}\n`;
        msg += `📊 إجمالي ساعات التشغيل: *${fmtH(totalHours)}* ساعة\n`;
        msg += `${sep}\n`;
        msg += `\n${closing}`;
        setPreview(msg);
      }
    } else if (msgType === 'comprehensive') {
      setPreview(buildComprehensiveMsg(partners[0], data));
    } else if (msgType === 'schedule_all') {
      if (scheduleAllData) setPreview(buildScheduleAllMsg());
    } else if (msgType === 'schedule_one') {
      if (scheduleAllData) setPreview(buildScheduleOneMsg(partners[0], scheduleAllData));
    } else {
      setPreview(buildMsg(partners[0]));
    }
  }, [partners, msgType, reportData, billSessions, scheduleAllData, fromDate, toDate, data]);


  const sendViaApiDirect = async (phone, msg, extraParams = {}) => {
    try {
      const token = localStorage.getItem('token');
      const body = { phone: phone.replace(/\D/g,''), message: msg, ...extraParams };
      const res = await fetch('/api/send-whatsapp/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.messages) return true;
      else { console.error('فشل الإرسال:', data); return false; }
    } catch(e) {
      console.error('خطأ:', e); return false;
    }
  };
  const canSendApi    = isAdmin || (currentUser && (currentUser.permissions||[]).includes('whatsapp_api'));
  const [withBrothers, setWithBrothers] = React.useState(false);
  const canSendManual = isAdmin || (currentUser && (currentUser.permissions||[]).includes('whatsapp_manual'));

  const sendToPartner = async (p) => {
    if (!canSendApi) { alert('ليس لديك صلاحية الإرسال عبر API'); return; }
    if (!p.phone) { alert(`⚠️ لا يوجد رقم واتساب لـ ${p.name}\nأضف الرقم من لوحة التحكم`); return; }
    startQueue([p]);
  };
  const sendToPartnerAndBrothers = async (p) => {
    const phones = [p.phone, ...(p.extra_phones||'').split(',').map(s=>s.trim())].filter(Boolean);
    if (phones.length === 0) { alert(`⚠️ لا توجد أرقام واتساب لـ ${p.name}\nأضف الأرقام من لوحة التحكم`); return; }
    const isComprehensive = msgType === 'comprehensive';
    const isBillCurrentOne = msgType === 'bill_current_one';
    const isPartnerType = ['account','schedule','expenses','bills','both','schedule_one','bill_schedule'].includes(msgType);
    const isAllGroupType = ['bill_current_all', 'group_summary', 'schedule_all'].includes(msgType);
    const isApiReport = isComprehensive || isBillCurrentOne || isPartnerType || isAllGroupType;
    let sharedUrl = '';
    if (isAllGroupType) {
      const linkRes = await API.post('/create-report-link/', {
        report_type: msgType,
        partnership_id: partnership.id,
        from_date: fromDate,
        to_date: toDate,
      }).catch(()=>null);
      sharedUrl = linkRes?.data?.url || '';
      if (!sharedUrl) { alert('❌ فشل إنشاء الرابط'); return; }
    }
    // إنشاء رابط واحد مسبقاً لجميع أرقام الشريك
    let partnerSingleUrl = '';
    if (isPartnerType || isComprehensive || isBillCurrentOne) {
      try {
        const linkRes = await API.post('/create-report-link/', {
          report_type: isComprehensive ? 'account_report' : msgType,
          partner_id: p.id,
          from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
          to_date: toDate,
          partnership_id: partnership.id,
        });
        partnerSingleUrl = linkRes?.data?.url || '';
      } catch(e) {}
    }
    const extraParams = isComprehensive ? {
      report_type: 'account_report',
      partner_id: p.id,
      from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
      to_date: toDate,
      partnership_id: partnership.id,
      _url: partnerSingleUrl,
    } : isBillCurrentOne ? {
      report_type: 'bill_current_one',
      partner_id: p.id,
      partnership_id: partnership.id,
      _url: partnerSingleUrl,
    } : isPartnerType ? {
      report_type: msgType,
      partner_id: p.id,
      from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
      to_date: toDate,
      partnership_id: partnership.id,
      _url: partnerSingleUrl,
    } : isAllGroupType ? {
      report_type: msgType,
      partnership_id: partnership.id,
      from_date: fromDate,
      to_date: toDate,
      _url: sharedUrl,
    } : {};
    const msg = isApiReport ? '' : await buildMsgForPartner(p);
    let sent = 0;
    for (const ph of phones) {
      const ok = await sendViaApiDirect(ph, msg, extraParams);
      if (ok) sent++;
    }
    if (sent > 0) alert(`✅ تم إرسال الرسالة لـ ${sent} رقم`);
  };
  const sendToPartnerAndBrothersManual = async (p) => {
    const phones = [p.phone, ...(p.extra_phones||'').split(',').map(s=>s.trim())].filter(Boolean);
    if (phones.length === 0) { alert(`⚠️ لا توجد أرقام واتساب لـ ${p.name}\nأضف الأرقام من لوحة التحكم`); return; }
    const msg = await buildMsgForPartner(p);
    const allNums = phones.map((ph,i) => `${i+1}. ${ph.replace(/\D/g,'')}`).join('\n');
    const confirmed = window.confirm(`إرسال يدوي لـ ${p.name}\nسيتم فتح واتساب لـ ${phones.length} رقم:\n${allNums}\n\nاضغط موافق للبدء`);
    if (!confirmed) return;
    for (let i=0; i<phones.length; i++) {
      const ph = phones[i].replace(/\D/g,'');
      const url = `https://wa.me/${ph}?text=${encodeURIComponent(msg)}`;
      window.open(url, '_blank');
      API.post('/whatsapp-log-manual/', {
        partnership_id: partnership.id,
        partner_id: p.id,
        phone: ph,
        message: msg,
      }).catch(()=>{});
      if (i < phones.length - 1) {
        await new Promise(r => setTimeout(r, 800));
      }
    }
  };

  const buildMsgForPartner = async (p) => {
    if (msgType === 'group_summary') return buildGroupMsg();
    if (msgType === 'bill_current_all') return buildBillAllMsg();
    if (msgType === 'bill_current_one') return buildBillOneMsg(p);
    if (msgType === 'bill_current') {
      const res = await API.get(`/bill-sessions/${partnership.id}/?partner_id=${p.id}`);
      return buildBillMsg(p, res.data.sessions||[], res.data.bill);
    }
    if (msgType === 'comprehensive') return buildComprehensiveMsg(p, data);
    if (msgType === 'schedule_all' || msgType === 'schedule_one') {
      let sdata = scheduleAllData;
      if (!sdata) {
        const res = await API.get(`/reports/${partnership.id}/?type=schedule_dates&from_date=${fromDate}&to_date=${toDate}`);
        sdata = res.data;
        setScheduleAllData(sdata);
      }
      if (msgType === 'schedule_all') return buildScheduleAllMsg();
      return buildScheduleOneMsg(p, sdata);
    }
    return buildMsg(p);
  };

  const startQueue = async (toSend) => {
    if (!toSend.length) { alert('لا توجد أرقام واتساب'); return; }
    const isAllGroupType = ['bill_current_all', 'group_summary', 'schedule_all'].includes(msgType);
    let sharedUrl = '';
    if (isAllGroupType) {
      const linkRes = await API.post('/create-report-link/', {
        report_type: msgType,
        partnership_id: partnership.id,
        from_date: fromDate,
        to_date: toDate,
      }).catch(()=>null);
      sharedUrl = linkRes?.data?.url || '';
      if (!sharedUrl) { alert('❌ فشل إنشاء الرابط'); return; }
    }
    // إنشاء روابط مسبقاً لكل شريك فريد
    const uniquePartners = [...new Map(toSend.map(p => [p.id, p])).values()];
    const partnerLinks = {};
    for (const p of uniquePartners) {
      const isPartnerTypeCheck = ['account','schedule','expenses','bills','both','schedule_one','bill_schedule','comprehensive','bill_current_one'].includes(msgType);
      if (isPartnerTypeCheck) {
        try {
          const linkRes = await API.post('/create-report-link/', {
            report_type: msgType === 'comprehensive' ? 'account_report' : msgType,
            partner_id: p.id,
            from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
            to_date: toDate,
            partnership_id: partnership.id,
          });
          partnerLinks[p.id] = linkRes?.data?.url || '';
        } catch(e) { partnerLinks[p.id] = ''; }
      }
    }
    const list = await Promise.all(toSend.map(async (p, i) => {
      const isComprehensive = msgType === 'comprehensive';
      const isBillCurrentOne = msgType === 'bill_current_one';
      const isPartnerType = ['account','schedule','expenses','bills','both','schedule_one','bill_schedule'].includes(msgType);
      const isApiReport = isComprehensive || isBillCurrentOne || isPartnerType || isAllGroupType;
      const partnerUrl = partnerLinks[p.id] || '';
      const extraParams = isComprehensive ? {
        report_type: 'account_report',
        partner_id: p.id,
        from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
        to_date: toDate,
        partnership_id: partnership.id,
      } : isBillCurrentOne ? {
        report_type: 'bill_current_one',
        partner_id: p.id,
        partnership_id: partnership.id,
      } : isPartnerType ? {
        report_type: msgType,
        partner_id: p.id,
        from_date: ['schedule_one','bill_schedule'].includes(msgType) ? fromDate : (data?.partnership?.start_date || fromDate),
        to_date: toDate,
        partnership_id: partnership.id,
      } : isAllGroupType ? {
        report_type: msgType,
        partnership_id: partnership.id,
        from_date: fromDate,
        to_date: toDate,
        _url: sharedUrl,
      } : {};
      // إضافة الرابط المحسوب مسبقاً للأنواع الفردية
      if ((isComprehensive || isBillCurrentOne || isPartnerType) && partnerUrl) {
        extraParams._url = partnerUrl;
      }
      const msg = isApiReport ? '' : await buildMsgForPartner(p);
      return { partner: p.name, phone: p.phone.replace(/\D/g,''), msg, extraParams, idx: i+1, total: toSend.length };
    }));
    const isApiQueue = list.every(item => item.extraParams && Object.keys(item.extraParams).length > 0);
    if (isApiQueue) {
      let sent = 0;
      for (const item of list) {
        const ok = await sendViaApiDirect(item.phone, item.msg, item.extraParams);
        if (ok) sent++;
      }
      alert(`✅ تم الإرسال لـ ${sent} من ${list.length} شريك`);
      return;
    }
    setQueue(list);
    setQueueIdx(0);
    setShowQueue(true);
    await sendViaApiDirect(list[0].phone, list[0].msg, list[0].extraParams);
    if (list.length === 1) {
      setTimeout(() => { setShowQueue(false); setQueue([]); }, 4000);
    }
  };

  const startManualQueue = async (toSend) => {
    const list = [];
    for (const p of toSend) {
      const msg = await buildMsgForPartner(p);
      const phones = [p.phone, ...(p.extra_phones||'').split(',').map(s=>s.trim())].filter(Boolean);
      phones.forEach(ph => list.push({ partner: p.name, phone: ph.replace(/\D/g,''), msg, id: p.id }));
    }
    setManualQueue(list);
    setManualQueueIdx(0);
    setShowManualQueue(true);
    window.open(`https://wa.me/${list[0].phone}?text=${encodeURIComponent(list[0].msg)}`,'_blank');
    API.post('/whatsapp-log-manual/',{partnership_id:partnership.id,partner_id:toSend[0].id,phone:toSend[0].phone,message:list[0].msg}).catch(()=>{});
  };

  const manualQueueNext = () => {
    const next = manualQueueIdx + 1;
    if (next >= manualQueue.length) { setShowManualQueue(false); setManualQueue([]); return; }
    setManualQueueIdx(next);
    const item = manualQueue[next];
    window.open(`https://wa.me/${item.phone}?text=${encodeURIComponent(item.msg)}`,'_blank');
    API.post('/whatsapp-log-manual/',{partnership_id:partnership.id,partner_id:item.id,phone:item.phone,message:item.msg}).catch(()=>{});
  };

  const sendSelected = () => {
    let toSend = partners.filter(p => selected[p.id] && p.phone);
    if (!toSend.length) { alert('يرجى تحديد شريك واحد على الأقل مع رقم واتساب'); return; }
    if (withBrothers) { const exp=[]; toSend.forEach(p=>{exp.push(p);if(p.extra_phones)p.extra_phones.split(',').map(s=>s.trim()).filter(Boolean).forEach(ph=>exp.push({...p,phone:ph,extra_phones:''}));}); toSend=exp; }
    startQueue(toSend);
  };

  const sendAll = () => {
    const allTypes = ['bill_current_all', 'group_summary', 'schedule_all'];
    if (allTypes.includes(msgType)) {
      const phones = partners.filter(p => p.phone).map(p => p.phone);
      if (!phones.length) { alert('لا توجد أرقام واتساب'); return; }
      const token = localStorage.getItem('token');
      fetch('/api/create-report-link/', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Authorization': `Token ${token}`},
        body: JSON.stringify({report_type: msgType, partnership_id: partnership.id, from_date: fromDate, to_date: toDate})
      }).then(r => r.json()).then(data => {
        if (!data.url) { alert('❌ فشل إنشاء الرابط'); return; }
        const extraParams = {report_type: msgType, partnership_id: partnership.id, from_date: fromDate, to_date: toDate, _url: data.url};
        let sent = 0;
        phones.reduce((promise, phone) =>
          promise.then(() => sendViaApiDirect(phone, '', extraParams).then(ok => { if (ok) sent++; }))
        , Promise.resolve()).then(() => {
          alert(`✅ تم الإرسال لـ ${sent} من ${phones.length} رقم`);
        });
      });
      return;
    }
    let toSend = partners.filter(p => p.phone);
    if (!toSend.length) { alert('لا توجد أرقام واتساب — أضفها في لوحة التحكم'); return; }
    if (withBrothers) { const exp=[]; toSend.forEach(p=>{exp.push(p);if(p.extra_phones)p.extra_phones.split(',').map(s=>s.trim()).filter(Boolean).forEach(ph=>exp.push({...p,phone:ph,extra_phones:''}));}); toSend=exp; }
    startQueue(toSend);
  };

  const queueNext = async () => {
    const next = queueIdx + 1;
    if (next >= queue.length) { setShowQueue(false); setQueue([]); return; }
    setQueueIdx(next);
    await sendViaApiDirect(queue[next].phone, queue[next].msg, queue[next].extraParams || {});
    if (next === queue.length - 1) {
      setTimeout(() => { setShowQueue(false); setQueue([]); }, 4000);
    }
  };

  const toggleAll = () => {
    const allSelected = partners.every(p => selected[p.id]);
    const newSel = {};
    partners.forEach(p => { newSel[p.id] = !allSelected; });
    setSelected(newSel);
  };

  const debtors = partners.filter(p => parseFloat(p.balance||0) < -0.01);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [showArchive, setShowArchive] = useState(false);
  const [waStats, setWaStats] = useState([]);
  const [editingLimit, setEditingLimit] = useState({});

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`/api/whatsapp-stats/?partnership_id=${partnership.id}`, { headers: {'Authorization': `Token ${token}`} })
      .then(r => r.json()).then(d => setWaStats(Array.isArray(d) ? d : []));
    fetch(`/api/whatsapp-monthly-stats/?partnership_id=${partnership.id}`, { headers: {'Authorization': `Token ${token}`} })
      .then(r => r.json()).then(d => setMonthlyStats(d)).catch(()=>{});
  }, []);

  const updateLimit = async (partnership_id, limit) => {
    const token = localStorage.getItem('token');
    const res = await fetch('/api/whatsapp-stats/', {
      method: 'POST',
      headers: {'Authorization': `Token ${token}`, 'Content-Type': 'application/json'},
      body: JSON.stringify({partnership_id, limit})
    });
    if (res.ok) {
      setWaStats(prev => prev.map(s => s.partnership_id === partnership_id ? {...s, limit, remaining: Math.max(0, limit - s.sent)} : s));
      setEditingLimit({});
    }
  };
  React.useEffect(() => {
    if (showQueue) {
      const t = setTimeout(() => { setShowQueue(false); setQueue([]); }, 4000);
      return () => clearTimeout(t);
    }
  }, [showQueue, queueIdx]);
  const [archiveLogs, setArchiveLogs] = useState([]);
  const [monthlyStats, setMonthlyStats] = useState(null);
  const [archiveFilter, setArchiveFilter] = useState({partnership_id:'', phone:'', date_from:'', date_to:'', status:''});
  const [archiveLoading, setArchiveLoading] = useState(false);
  if (!data) return <div style={{textAlign:'center',padding:'40px'}}>جاري التحميل...</div>;

  const buildBillOneMsg = (p) => {
    const sep = '─'.repeat(28);
    const fmtN = (n) => Number(n||0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits:2,maximumFractionDigits:2});
    const lastBill = data?.bill_details?.[data.bill_details.length-1];
    if (!lastBill) return 'لا توجد فاتورة';
    const share = lastBill.shares?.[String(p.id)] || lastBill.shares?.[p.id] || 0;
    const totalMinsB = lastBill.partner_minutes?.[String(p.id)] ?? ((lastBill.partner_hours?.[String(p.id)]||0) + (lastBill.partner_extra_hours?.[String(p.id)]||0))*60;
    const totalHrs = totalMinsB/60;
    const bal = parseFloat(p.balance || 0);
    const balTxt = Math.abs(bal)<0.01 ? '✅ مسدد رصيد 0' : bal>0 ? `✅ له رصيد +${fmtN(bal)}` : `❌ مديون ${fmtN(Math.abs(bal))}`;
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `المكرم الأخ / ${p.name} حفظكم الله\n`;
    msg += `${greeting}\n`;
    msg += `${sep}\n`;
    msg += `📋 *صدرت الفاتورة الحالية*\n`;
    msg += `خلال الفترة من ${lastBill.from_date} إلى ${lastBill.to_date}\n`;
    msg += `${sep}\n`;
    const hrsInt = Math.floor(totalHrs);
    const minsRem = Math.round((totalHrs - hrsInt) * 60);
    const hrsDisp = minsRem > 0 ? `${hrsInt} ساعة و${minsRem} دقيقة` : `${hrsInt} ساعة`;
    msg += `• المبلغ الكلي للفاتورة: *${fmtN(lastBill.amount)}* ريال\n`;
    msg += `${sep}\n`;
    msg += `⏱️ ساعات التشغيل الخاصة بكم مدة الفاتورة: *${hrsDisp}*\n`;
    if (partnership.quota_type === 'days') {
      const exBillOne = sumExactDH(data?.sessions, lastBill.from_date, lastBill.to_date, p.id);
      msg += `📅 أيام/ساعات التشغيل مدة الفاتورة: *${fmtExactDH(exBillOne.days, exBillOne.hours)}*\n`;
    }
    msg += `${sep}\n`;
    msg += `👤 تكاليف الفاتورة الشهرية الخاصة بكم: ${fmtN(share)} ريال\n`;
    msg += `حالة الرصيد: ${balTxt}\n`;
    return msg;
  };

  const buildBillAllMsg = () => {
    const sep = '─'.repeat(28);
    const fmtN = (n) => Number(n||0).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits:2,maximumFractionDigits:2});
    const lastBill = data?.bill_details?.[data.bill_details.length-1];
    if (!lastBill) return 'لا توجد فاتورة';
    let msg = `💧 *بئر الشراكة ( ${partnership.name} )*\n`;
    msg += `${sep}\n`;
    msg += `🧾 *فاتورة رقم (${lastBill.number})*\n`;
    msg += `من ${lastBill.from_date} إلى ${lastBill.to_date}\n`;
    msg += `${sep}\n`;
    msg += `• المبلغ: *${fmtN(lastBill.amount)}* ريال\n`;
    msg += `${sep}\n`;
    partners.forEach(p => {
      const share = lastBill.shares?.[String(p.id)] || lastBill.shares?.[p.id] || 0;
      const bal = parseFloat(p.balance || 0);
      const balTxt = Math.abs(bal)<0.01 ? '✅ مسدد رصيد 0' : bal>0 ? `✅ له رصيد +${fmtN(bal)}` : `❌ مديون ${fmtN(Math.abs(bal))}`;
      msg += `👤 *${p.name}*: ${fmtN(share)} ريال · ${balTxt}\n`;
    });
    return msg;
  };

  const msgTypes = [
    {value:'comprehensive', label:'📊 تقرير شامل'},
    {value:'bill_current_all', label:'🧾 الفاتورة الحالية - الكل'},
    {value:'bill_current_one', label:'🧾 الفاتورة الحالية - شريك'},
    {value:'account', label:'💰 الحساب فقط'},
    {value:'schedule', label:'⚡ التشغيل فقط'},
    {value:'expenses', label:'📋 المصروفات فقط'},
    {value:'bills', label:'🔌 الفواتير فقط'},
    {value:'both', label:'📊 الحساب + التشغيل + المصروفات'},
    {value:'group_summary', label:'👥 ملخص جماعي (للمجموعة)'},
    {value:'schedule_all', label:'📅 جدول التشغيل - الكل'},
    {value:'schedule_one', label:'📅 جدول تشغيلك القادم - شريك'},
    {value:'bill_schedule', label:'📅 جدول التشغيل خلال الفاتورة - شريك'},
  ];


  const loadArchive = async (filter) => {
    setArchiveLoading(true);
    const token = localStorage.getItem('token');
    const params = new URLSearchParams();
    if (filter.partnership_id) params.append('partnership_id', filter.partnership_id);
    if (filter.partner_id) params.append('partner_id', filter.partner_id);
    if (filter.phone) params.append('phone', filter.phone);
    if (filter.date_from) params.append('date_from', filter.date_from);
    if (filter.date_to) params.append('date_to', filter.date_to);
    if (filter.status) params.append('status', filter.status);
    const res = await fetch('/api/whatsapp-logs/?' + params.toString(), {
      headers: {'Authorization': `Token ${token}`}
    });
    const data = await res.json();
    setArchiveLogs(Array.isArray(data) ? data : []);
    setArchiveLoading(false);
  };

  const printArchive = () => {
    const rows = archiveLogs.map(l => `
      <tr>
        <td>${l.sent_at}</td>
        <td>${l.partnership}</td>
        <td>${l.partner}</td>
        <td>${l.phone}</td>
        <td style="white-space:pre-wrap;max-width:300px">${l.message}</td>
        <td style="color:${l.status==='success'?'green':'red'}">${l.status==='success'?'نجح':'فشل'}</td>
      </tr>`).join('');
    const _html = (`<html dir="rtl"><head><meta charset="utf-8"><title>أرشيف رسائل واتساب</title>
      <style>body{font-family:Arial;font-size:12px} table{width:100%;border-collapse:collapse} th,td{border:1px solid #ccc;padding:6px;text-align:right}</style>
      </head><body><h2>أرشيف رسائل واتساب</h2>
      <table><thead><tr><th>التاريخ</th><th>الشراكة</th><th>الشريك</th><th>الرقم</th><th>الرسالة</th><th>الحالة</th></tr></thead>
      <tbody>${rows}</tbody></table></body></html>`);
    printHtml(_html);
  };

  return (
    <div style={{padding:'20px',direction:'rtl'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
        <h3 style={{color:'#1e3a5f',margin:0}}>💬 إرسال رسائل واتساب</h3>
        <button onClick={()=>{setShowArchive(true);loadArchive(archiveFilter);}}
          style={{padding:'8px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px'}}>
          🗂️ أرشيف الرسائل
        </button>
      </div>

      {waStats.length > 0 && (
        <div style={{marginBottom:'16px'}}>
          {waStats.map(s => (
            <div key={s.partnership_id} style={{background:'white',borderRadius:'10px',padding:'14px 18px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)',marginBottom:'8px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'10px'}}>
                <div style={{fontWeight:'bold',color:'#1e3a5f',fontSize:'14px'}}>📊 {s.partnership_name}</div>
                <div style={{display:'flex',gap:'16px',alignItems:'center',flexWrap:'wrap'}}>
                  <span style={{fontSize:'13px',color:'#27ae60'}}>✅ مُرسل: <b>{s.sent}</b></span>
                  <span style={{fontSize:'13px',color:'#e67e22'}}>⏳ متبقي: <b>{s.remaining}</b></span>
                  {monthlyStats && monthlyStats[s.partnership_id] && <>
                    <span style={{borderLeft:'2px solid #ddd',paddingLeft:'16px',marginLeft:'6px'}}></span>
                    <span style={{fontSize:'13px',color:'#2980b9'}}>💬 API: <b>{monthlyStats[s.partnership_id]?.api_count||0}</b> رسالة</span>
                    <span style={{fontSize:'13px',color:'#e74c3c'}}>💰 <b>{monthlyStats[s.partnership_id]?.api_cost||0}</b> ريال</span>
                    <span style={{borderLeft:'2px solid #ddd',paddingLeft:'16px',marginLeft:'6px'}}></span>
                    <span style={{fontSize:'13px',color:'#075e54'}}>📱 يدوي: <b>{monthlyStats[s.partnership_id]?.manual_count||0}</b> رسالة</span>
                  </>}
                  <span style={{fontSize:'13px',color:'#7f8c8d'}}>
                    الحد: {s.is_admin && editingLimit[s.partnership_id] !== undefined ? (
                      <span>
                        <input type="number" value={editingLimit[s.partnership_id]}
                          onChange={e=>setEditingLimit({...editingLimit,[s.partnership_id]:parseInt(e.target.value)||0})}
                          style={{width:'60px',padding:'2px 6px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px',marginRight:'4px'}}/>
                        <button onClick={()=>updateLimit(s.partnership_id, editingLimit[s.partnership_id])}
                          style={{padding:'2px 8px',background:'#27ae60',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px',marginLeft:'4px'}}>✔</button>
                        <button onClick={()=>setEditingLimit({})}
                          style={{padding:'2px 8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px',marginLeft:'4px'}}>✕</button>
                      </span>
                    ) : (
                      <span>
                        <b>{s.limit}</b>
                        {isAdmin && <button onClick={()=>setEditingLimit({...editingLimit,[s.partnership_id]:s.limit})}
                          style={{padding:'1px 6px',background:'#3498db',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'10px',marginRight:'6px'}}>✏️</button>}
                      </span>
                    )}
                  </span>
                </div>
              </div>
              <div style={{marginTop:'8px',height:'6px',background:'#ecf0f1',borderRadius:'3px',overflow:'hidden'}}>
                <div style={{height:'100%',borderRadius:'3px',background: s.sent >= s.limit ? '#e74c3c' : s.sent/s.limit > 0.7 ? '#e67e22' : '#27ae60',width:`${Math.min(100,(s.sent/s.limit)*100)}%`,transition:'width 0.5s'}}></div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showArchive && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'flex-start',justifyContent:'center',padding:'20px',overflowY:'auto'}}>
          <div style={{background:'white',borderRadius:'12px',width:'100%',maxWidth:'1000px',direction:'rtl',marginTop:'20px'}}>
            <div style={{padding:'16px 20px',borderBottom:'1px solid #eee',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <h3 style={{margin:0,color:'#1e3a5f'}}>🗂️ أرشيف رسائل واتساب</h3>
              <button onClick={()=>setShowArchive(false)} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>✕</button>
            </div>
            <div style={{padding:'16px 20px',background:'#f8f9fa',borderBottom:'1px solid #eee'}}>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))',gap:'10px',marginBottom:'10px'}}>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>الشراكة</label>
                  <select value={archiveFilter.partnership_id} onChange={e=>{const f={...archiveFilter,partnership_id:e.target.value};setArchiveFilter(f);}}
                    style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}>
                    <option value=''>الكل</option>
                    {partnership && <option value={partnership.id}>{partnership.name}</option>}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>اسم الشريك</label>
                  <select value={archiveFilter.partner_id||''} onChange={e=>{const f={...archiveFilter,partner_id:e.target.value};setArchiveFilter(f);}}
                    style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}>
                    <option value=''>الكل</option>
                    {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>رقم الهاتف</label>
                  <input value={archiveFilter.phone} onChange={e=>{const f={...archiveFilter,phone:e.target.value};setArchiveFilter(f);}}
                    placeholder="ابحث برقم..." style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>من تاريخ</label>
                  <input type="date" value={archiveFilter.date_from} onChange={e=>{const f={...archiveFilter,date_from:e.target.value};setArchiveFilter(f);}}
                    style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}/>
                </div>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>إلى تاريخ</label>
                  <input type="date" value={archiveFilter.date_to} onChange={e=>{const f={...archiveFilter,date_to:e.target.value};setArchiveFilter(f);}}
                    style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}/>
                </div>
                <div>
                  <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>نوع الإرسال</label>
                <select value={archiveFilter.send_type||''} onChange={e=>setArchiveFilter({...archiveFilter,send_type:e.target.value})}
                  style={{padding:'6px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'12px',width:'100%'}}>
                  <option value=''>الكل</option>
                  <option value='api'>💬 API مدفوع</option>
                  <option value='manual'>📱 يدوي مجاني</option>
                </select>
                <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'3px'}}>الحالة</label>
                  <select value={archiveFilter.status} onChange={e=>{const f={...archiveFilter,status:e.target.value};setArchiveFilter(f);}}
                    style={{width:'100%',padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px'}}>
                    <option value=''>الكل</option>
                    <option value='success'>نجح</option>
                    <option value='failed'>فشل</option>
                  </select>
                </div>
              </div>
              <div style={{display:'flex',gap:'8px'}}>
                <button onClick={()=>loadArchive(archiveFilter)}
                  style={{padding:'7px 16px',background:'#2980b9',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
                  🔍 بحث
                </button>
                <button onClick={()=>{const f={partnership_id:'',phone:'',date_from:'',date_to:'',status:'',send_type:''};setArchiveFilter(f);loadArchive(f);}}
                  style={{padding:'7px 16px',background:'#95a5a6',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
                  🔄 إعادة تعيين
                </button>
                <button onClick={printArchive}
                  style={{padding:'7px 16px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
                  🖨️ طباعة
                </button>
                <span style={{marginRight:'auto',fontSize:'12px',color:'#666',alignSelf:'center'}}>
                  {archiveLogs.length} رسالة
                </span>
              </div>
            </div>
            <div style={{overflowY:'auto',maxHeight:'60vh'}}>
              {archiveLoading ? (
                <div style={{padding:'40px',textAlign:'center',color:'#666'}}>جاري التحميل...</div>
              ) : archiveLogs.length === 0 ? (
                <div style={{padding:'40px',textAlign:'center',color:'#999'}}>لا توجد رسائل</div>
              ) : (
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:'12px'}}>
                  <thead>
                    <tr style={{background:'#f0f0f0',position:'sticky',top:0}}>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>التاريخ والوقت</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>الشراكة</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>الشريك</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>الرقم</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right',minWidth:'200px'}}>الرسالة</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>نوع الإرسال</th>
                      <th style={{padding:'10px',border:'1px solid #ddd',textAlign:'right'}}>الحالة</th>
                    </tr>
                  </thead>
                  <tbody>
                    {archiveLogs.map((log,i)=>(
                      <tr key={log.id} style={{background:i%2===0?'white':'#fafafa'}}>
                        <td style={{padding:'8px 10px',border:'1px solid #eee',whiteSpace:'nowrap'}}>{log.sent_at}</td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee'}}>{log.partnership}</td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee'}}>{log.partner}</td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee',direction:'ltr'}}>{log.phone}</td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee',whiteSpace:'pre-wrap',maxWidth:'300px',fontSize:'11px'}}>{log.message}</td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee',textAlign:'center'}}>
                          {log.send_type==='manual'?'📱 يدوي':'💬 API'}
                        </td>
                        <td style={{padding:'8px 10px',border:'1px solid #eee',textAlign:'center',color:log.status==='success'?'#27ae60':'#e74c3c',fontWeight:'bold'}}>
                          {log.status==='success'?'✅ نجح':'❌ فشل'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}

      <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'15px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'15px',marginBottom:'15px'}}>
          <div>
            <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>نوع الرسالة</label>
            <select value={msgType} onChange={e=>setMsgType(e.target.value)}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              {msgTypes.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
          {(msgType === 'schedule_all' || msgType === 'schedule_one') && (
          <div>
            <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>من تاريخ</label>
            <input type="date" value={fromDate} onChange={e=>setFromDate(e.target.value)}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}/>
          </div>
          )}
          {(msgType === 'schedule_all' || msgType === 'schedule_one') && (
          <div>
            <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>إلى تاريخ</label>
            <input type="date" value={toDate} onChange={e=>setToDate(e.target.value)}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}/>
          </div>
          )}
        </div>
        {msgType === 'bill_schedule' && (
          <div style={{marginBottom:'15px'}}>
            <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>اختر الفاتورة</label>
            <select value={selectedBillId||''} onChange={e=>setSelectedBillId(Number(e.target.value))}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px'}}>
              {(data?.bill_details||[]).map(b=>(
                <option key={b.id} value={b.id}>فاتورة {b.number} · من {b.from_date} إلى {b.to_date}</option>
              ))}
            </select>
          </div>
        )}
        {waAcc?.whatsapp_api_note && (
          <div style={{background:'#fffbea',border:'1px solid #f0d060',borderRadius:'8px',padding:'10px 14px',fontSize:'12px',color:'#7a6000',direction:'rtl',whiteSpace:'pre-line',marginBottom:'10px'}}>
            {waAcc.whatsapp_api_note}
          </div>
        )}
        <div style={{display:'flex',gap:'8px',flexWrap:'wrap',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            {canSendApi && <button onClick={sendAll} style={{padding:'10px 14px',background:'#25D366',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'bold',fontSize:'12px'}}>💬 API للجميع</button>}
            {canSendApi && <button onClick={sendSelected} style={{padding:'10px 14px',background:'#27ae60',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'bold',fontSize:'12px'}}>💬 API للمحددين</button>}
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            {canSendManual && <button onClick={async ()=>{
              let list=partners.filter(p=>p.phone);
              if(!list.length){alert('لا يوجد شركاء');return;}
              if(withBrothers){const exp=[];list.forEach(p=>{exp.push(p);if(p.extra_phones)p.extra_phones.split(',').map(s=>s.trim()).filter(Boolean).forEach(ph=>exp.push({...p,phone:ph,extra_phones:''}));});list=exp;}
              startManualQueue(list);
            }} style={{padding:'10px 14px',background:'#075e54',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'bold',fontSize:'12px'}}>📱 يدوي للجميع</button>}
            {canSendManual && <button onClick={async ()=>{
              let sel=partners.filter(p=>p.phone&&selected[p.id]);
              if(!sel.length){alert('لا يوجد شركاء محددون');return;}
              if(withBrothers){const exp=[];sel.forEach(p=>{exp.push(p);if(p.extra_phones)p.extra_phones.split(',').map(s=>s.trim()).filter(Boolean).forEach(ph=>exp.push({...p,phone:ph,extra_phones:''}));});sel=exp;}
              startManualQueue(sel);
            }} style={{padding:'10px 14px',background:'#1a7a5e',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontWeight:'bold',fontSize:'12px'}}>📱 يدوي للمحددين</button>}
          </div>
          <label style={{display:'inline-flex',alignItems:'center',gap:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold',background:'#f0f4f8',padding:'8px 14px',borderRadius:'8px',border:'1px solid #ddd'}}>
            <input type="checkbox" checked={withBrothers} onChange={e=>setWithBrothers(e.target.checked)} style={{width:'16px',height:'16px',cursor:'pointer'}}/>
            👥 مع الإخوة
          </label>
        </div>

      </div>

      <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'15px'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
          <h4 style={{margin:0,color:'#1e3a5f'}}>الشركاء</h4>
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={toggleAll} style={{padding:'5px 12px',background:'#f0f4f8',border:'1px solid #ddd',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
              {partners.every(p=>selected[p.id]) ? 'إلغاء الكل' : 'تحديد الكل'}
            </button>
            <button onClick={()=>{const allSel=debtors.length>0&&debtors.every(p=>selected[p.id]);if(allSel){setSelected({});}else{const ns={};debtors.forEach(p=>{ns[p.id]=true;});setSelected(ns);}}} style={{padding:'5px 12px',background:'#e74c3c',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>
              ⚠️ المديونون ({debtors.length})
            </button>
          </div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(250px,1fr))',gap:'8px'}}>
          {partners.map(p => {
            const bal = parseFloat(p.balance||0);
            const hasPhone = !!p.phone;
            return (
              <div key={p.id} onClick={()=>hasPhone&&setSelected(s=>({...s,[p.id]:!s[p.id]}))}
                style={{display:'flex',alignItems:'center',gap:'8px',padding:'10px',background:p.color||'#f8f9fa',
                  border:`2px solid ${selected[p.id]?'#25D366':'#ddd'}`,borderRadius:'8px',
                  cursor:hasPhone?'pointer':'default',opacity:hasPhone?1:0.7}}>
                <input type="checkbox" checked={!!selected[p.id]} disabled={!hasPhone} onChange={()=>{}} style={{width:'16px',height:'16px'}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:'11px',fontWeight:'bold'}}>{p.name}</div>
                  <div style={{fontSize:'11px',color:bal<-0.01?'#e74c3c':bal>0.01?'#27ae60':'#888'}}>
                    {Math.abs(bal)<0.01?'مسدد':bal>0?`+ ${fmt(bal)}`:`- ${fmt(Math.abs(bal))}`}
                  </div>
                </div>
                {hasPhone
                  ? <div style={{display:'flex',gap:'4px'}}>
                    {canSendApi && <button onClick={e=>{e.stopPropagation();sendToPartner(p);}}
                      style={{padding:'4px 8px',background:'#25D366',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                      💬
                    </button>}
                    {canSendManual && <button onClick={async e=>{
                      e.stopPropagation();
                      const msg=await buildMsgForPartner(p);
                      window.open(`https://wa.me/${p.phone.replace(/\D/g,'')}?text=${encodeURIComponent(msg)}`,'_blank');
                      API.post('/whatsapp-log-manual/',{
                        partnership_id: partnership.id,
                        partner_id: p.id,
                        phone: p.phone,
                        message: msg,
                      }).catch(()=>{});
                    }}
                      title="فتح واتساب يدوياً"
                      style={{padding:'4px 8px',background:'#075e54',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                      📱
                    </button>}

                    {p.extra_phones && canSendApi && <button onClick={e=>{e.stopPropagation();sendToPartnerAndBrothers(p);}}
                      title="إرسال API للشريك وإخوانه (مدفوع)"
                      style={{padding:'4px 8px',background:'#16a085',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                      👥
                    </button>}
                    {p.extra_phones && canSendManual && <button onClick={e=>{e.stopPropagation();sendToPartnerAndBrothersManual(p);}}
                      title="إرسال يدوي للشريك وإخوانه (مجاني)"
                      style={{padding:'4px 8px',background:'#0e6655',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                      👥📱
                    </button>}
                  </div>
                  : <span style={{fontSize:'10px',color:'#e74c3c'}}>⚠️ لا رقم</span>
                }
              </div>
            );
          })}
        </div>
      </div>

      <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
          <h4 style={{margin:0,color:'#1e3a5f'}}>👁️ معاينة الرسالة</h4>
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={()=>copyToClipboard(preview)}
              style={{padding:'7px 15px',background:copied?'#27ae60':'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'bold'}}>
              {copied?'✅ تم النسخ':'📋 نسخ للمجموعة'}
            </button>
            <button onClick={()=>{ const all=partners.map(p=>msgType==='group_summary'?buildGroupMsg():buildMsg(p)).join('\n'+('─'.repeat(20))+'\n'); copyToClipboard(all); }}
              style={{padding:'7px 15px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'bold'}}>
              📋 نسخ رسائل الكل
            </button>
          </div>
        </div>
        <pre style={{background:'#e8f5e9',padding:'15px',borderRadius:'8px',fontSize:'13px',whiteSpace:'pre-wrap',fontFamily:'inherit',direction:'rtl',maxHeight:'300px',overflowY:'auto'}}>
          {preview}
        </pre>
      </div>

      {showManualQueue && manualQueue.length > 0 && (
        <div style={{position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'linear-gradient(135deg,#075e54,#128c7e)',borderRadius:'20px',padding:'40px 48px',textAlign:'center',direction:'rtl',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.4)',color:'white'}}>
            <div style={{fontSize:'56px',marginBottom:'8px'}}>📱</div>
            <div style={{fontSize:'22px',fontWeight:'bold',marginBottom:'8px'}}>تم فتح واتساب!</div>
            <div style={{fontSize:'16px',opacity:0.9,marginBottom:'6px'}}>{manualQueue[manualQueueIdx]?.partner}</div>
            <div style={{fontSize:'13px',opacity:0.7,marginBottom:'24px'}}>
              {manualQueueIdx+1} من {manualQueue.length}
              {manualQueue.length - manualQueueIdx - 1 > 0 ? ` — تبقى ${manualQueue.length-manualQueueIdx-1}` : ' — اكتمل الإرسال 🎉'}
            </div>
            <div style={{fontSize:'12px',opacity:0.8,marginBottom:'16px',background:'rgba(255,255,255,0.15)',padding:'8px 12px',borderRadius:'8px'}}>
              أرسل الرسالة في واتساب ثم اضغط "التالي"
            </div>
            <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
              <button onClick={manualQueueNext}
                style={{padding:'10px 24px',background:'rgba(255,255,255,0.2)',color:'white',border:'2px solid rgba(255,255,255,0.5)',borderRadius:'10px',cursor:'pointer',fontSize:'14px',fontWeight:'bold'}}>
                {manualQueue.length-manualQueueIdx-1 > 0 ? '⏭️ التالي' : '✔️ إغلاق'}
              </button>
              <button onClick={()=>{setShowManualQueue(false);setManualQueue([]);}}
                style={{padding:'10px 18px',background:'rgba(231,76,60,0.7)',color:'white',border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'13px'}}>
                ✕ إيقاف
              </button>
            </div>
            <div style={{marginTop:'20px',height:'4px',background:'rgba(255,255,255,0.2)',borderRadius:'2px',overflow:'hidden'}}>
              <div style={{height:'100%',background:'#25D366',borderRadius:'2px',width:`${((manualQueueIdx+1)/manualQueue.length)*100}%`,transition:'width 0.5s ease'}}></div>
            </div>
          </div>
        </div>
      )}
      {showQueue && (
        <div style={{position:'fixed',top:0,left:0,width:'100%',height:'100%',background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',animation:'fadeIn 0.3s ease'}}>
          <div style={{background:'linear-gradient(135deg,#1a5276,#2980b9)',borderRadius:'20px',padding:'40px 48px',textAlign:'center',direction:'rtl',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.4)',color:'white'}}>
            <div style={{fontSize:'56px',marginBottom:'8px',animation:'bounce 0.5s ease'}}>✅</div>
            <div style={{fontSize:'22px',fontWeight:'bold',marginBottom:'8px'}}>
              تم الإرسال!
            </div>
            <div style={{fontSize:'16px',opacity:0.9,marginBottom:'6px'}}>
              {queue[queueIdx]?.partner}
            </div>
            <div style={{fontSize:'13px',opacity:0.7,marginBottom:'24px'}}>
              {queueIdx+1} من {queue.length}
              {queue.length - queueIdx - 1 > 0 ? ` — تبقى ${queue.length-queueIdx-1}` : ' — اكتمل الإرسال 🎉'}
            </div>
            <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
              <button onClick={queueNext}
                style={{padding:'10px 24px',background:'rgba(255,255,255,0.2)',color:'white',border:'2px solid rgba(255,255,255,0.5)',borderRadius:'10px',cursor:'pointer',fontSize:'14px',fontWeight:'bold',backdropFilter:'blur(4px)'}}>
                {queue.length-queueIdx-1 > 0 ? '⏭️ التالي' : '✔️ إغلاق'}
              </button>
              <button onClick={()=>{setShowQueue(false);setQueue([]);}}
                style={{padding:'10px 18px',background:'rgba(231,76,60,0.7)',color:'white',border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'13px'}}>
                ✕ إيقاف
              </button>
            </div>
            <div style={{marginTop:'20px',height:'4px',background:'rgba(255,255,255,0.2)',borderRadius:'2px',overflow:'hidden'}}>
              <div style={{height:'100%',background:'#2ecc71',borderRadius:'2px',width:`${((queueIdx+1)/queue.length)*100}%`,transition:'width 0.5s ease'}}></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WhatsApp;
// force rebuild Sat Jul 18 12:09:06 PM UTC 2026
